import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** CRDB-only, so the admin page cannot read it off the team document. */
export const getAdminShopperAgentEmailConfig = {
  name: "getAdminShopperAgentEmailConfig" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: ShopperAgentEmailConfigSchema,
};
